import {
  FleetVehicleDriverEditFormValues,
  FleetVehicleDriverSearchFormValues,
} from "./types";

export const initialFleetVehicleDriverSearchForm: FleetVehicleDriverSearchFormValues =
  {
    search: "",
    vehicleId: null,
    source: null,
    expiryFrom: null,
    expiryTo: null,
  };

export const initialFleetVehicleDriverEditForm: FleetVehicleDriverEditFormValues =
  {
    contactId: null,
    userId: null,
    driversLicenceNumber: null,
    driversLicenceExpiry: null,
    identityCardNumber: null,
    identityCardExpiry: null,
    passportNumber: null,
    passportExpiry: null,
    driversLicenceUploads: [],
    identityCardUploads: [],
    passportUploads: [],
  };
